import { IconButton } from '@material-ui/core';
import { Lock, LockOpenOutlined } from '@material-ui/icons';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { Form, Icon } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, FieldArray, reduxForm } from 'redux-form';
import { BLUE, MKS_REQUEST_TYPES, RED } from '../../../_config/consts';
import KeyOutlinedIconCustom from '../../CustomIcons/KeyOutlinedIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import CustomField from '../Fields/CustomField.jsx';
import DropFileMultiField from '../Fields/DropFileMultiField.jsx';
import SelectableField from '../Fields/SelectableInput/SelectableField.jsx';
import FileCheckIconCustom from '../../CustomIcons/FileCheckIconCustom.jsx';
import TranslatableOption from '../Fields/TranslatableOption.jsx';

const requestTypeOptions = [
  { value: MKS_REQUEST_TYPES.KEY_DUPLICATION, label: "mksRequestTypeKeyDuplication" },
  { value: MKS_REQUEST_TYPES.CYLINDER_DUPLICATION, label: "mksRequestTypeCylinderDuplication" },
  { value: MKS_REQUEST_TYPES.KEY_EXTENSION, label: "mksRequestTypeKeyExtension" },
  { value: MKS_REQUEST_TYPES.CYLINDER_EXTENSION, label: "mksRequestTypeCylinderExtension" },
];
@connect(state => ({
  mks: state.mks,
  formValues: state.form.MksRequestForm && state.form.MksRequestForm.values,
}))
class MksRequestForm extends React.Component {

  renderKeyDuplicationItem({ fields, meta: { error, submitFailed } }) {
    const { mks: { keys: { data: keysData } } } = this.props;
    const keysContent = keysData && keysData.content ? keysData.content : [];
    
    const keyOptions = _.map(keysContent, key => ({
      value: key,
      label: `${key.designation || key.externalId || key.id} - ${key.keyFunction || ''}`,
    }));

    return (
      <div>
        {_.map(fields.getAll() || [], (item, index) => (
          <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 15, padding: 15, backgroundColor: '#fafafa', borderRadius: 8 }}>
            <div style={{ flex: 1, marginRight: 10 }}>
              <Field
                name={`${fields.name}[${index}].key`}
                component={SelectableField}
                title={<Entity entity="selectKey" />}
                placeholder={<Entity entity="selectKeyPlaceholder" />}
                options={keyOptions}
                mandatory
              />
            </div>
            <div style={{ flex: 0, minWidth: 150, marginRight: 10, marginTop: 30 }}>
              <Entity
                componentClass={Field}
                name={`${fields.name}[${index}].quantity`}
                componentAttribute="placeholder"
                entity="insertQuantity"
                title={<Entity entity="quantity" />}
                component={CustomField}
                mandatory
              />
            </div>
            <IconButton 
              onClick={() => fields.remove(index)} 
              style={{ marginTop: 40 }}
            >
              <RemoveCircleOutlineIcon style={{ color: RED, fontSize: 20 }} />
            </IconButton>
          </div>
        ))}
        <MDButton
          title={<Entity entity="addKeyDuplication" />}
          onClick={() => fields.push({ key: null, quantity: 1 })}
          containerStyle={{ marginTop: 10 }}
          icon={<AddCircleOutlineIcon style={{ fontSize: 20, marginLeft: 10 }} />}
          backgroundColor={BLUE}
        />
        {submitFailed && error && <h5 style={{ color: 'red', marginTop: 10 }}><Entity entity={error} /></h5>}
      </div>
    );
  }

  renderCylinderDuplicationItem({ fields, meta: { error, submitFailed } }) {
    const { mks: { cylinders: { data: cylindersData } } } = this.props;
    const cylindersContent = cylindersData && cylindersData.content ? cylindersData.content : [];
    
    const cylinderOptions = _.map(cylindersContent, cylinder => ({
      value: cylinder,
      label: `${cylinder.doorName || cylinder.marking || cylinder.externalId || cylinder.id} - ${cylinder.type || ''}`,
    }));

    return (
      <div>
        {_.map(fields.getAll() || [], (item, index) => (
          <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginBottom: 15, padding: 15, backgroundColor: '#fafafa', borderRadius: 8 }}>
            <div style={{ flex: 1, marginRight: 10 }}>
              <Field
                name={`${fields.name}[${index}].cylinder`}
                component={SelectableField}
                title={<Entity entity="selectCylinder" />}
                placeholder={<Entity entity="selectCylinderPlaceholder" />}
                options={cylinderOptions}
                mandatory
              />
            </div>
            <div style={{ flex: 0, minWidth: 150, marginRight: 10, marginTop: 15 }}>
              <Entity
                componentClass={Field}
                name={`${fields.name}[${index}].quantity`}
                componentAttribute="placeholder"
                entity="insertQuantity"
                title={<Entity entity="quantity" />}
                component={CustomField}
                mandatory
              />
            </div>
            <IconButton 
              onClick={() => fields.remove(index)} 
              style={{ marginTop: 30 }}
            >
              <RemoveCircleOutlineIcon style={{ color: RED, fontSize: 30 }} />
            </IconButton>
          </div>
        ))}
        <MDButton
          title={<Entity entity="addCylinderDuplication" />}
          onClick={() => fields.push({ cylinder: null, quantity: 1 })}
          containerStyle={{ marginTop: 10 }}
          icon={<AddCircleOutlineIcon style={{ fontSize: 20, marginLeft: 10 }} />}
          backgroundColor={BLUE}
        />
        {submitFailed && error && <h5 style={{ color: 'red', marginTop: 10 }}><Entity entity={error} /></h5>}
      </div>
    );
  }

  onRequestTypeSelected(requestType) {
    const { dispatch } = this.props;
    if (requestType) {
      dispatch(change('MksRequestForm', 'requestType', requestType));
      dispatch(change('MksRequestForm', 'duplicationItems', []));
      dispatch(change('MksRequestForm', 'cylindersDuplicates', []));
      dispatch(change('MksRequestForm', 'selectedKeys', []));
      dispatch(change('MksRequestForm', 'selectedCylinders', []));
    }
  }

  onDeleteFile(index) {
    const { dispatch, formValues } = this.props;
    const newDocuments = formValues.documents ? _.filter(formValues.documents, (document, i) => i !== index) : [];
    dispatch(change('MksRequestForm', 'documents', newDocuments));
  }

  render() {
    const { 
      formValues,
      mks: { keys: { data: keysData }, cylinders: { data: cylindersData } },
      onFileRejected,
    } = this.props;

    const requestType = formValues && formValues.requestType;
    const filePreviews = formValues && formValues.documents ? _.map(formValues.documents, document => ({
      name: document.name,
      preview: document.preview,
    })) : [];
  

    const keysContent = keysData && keysData.content ? keysData.content : [];
    const cylindersContent = cylindersData && cylindersData.content ? cylindersData.content : [];

    const keyOptions = _.map(keysContent, key => ({
      value: key,
      label: `${key.designation || key.externalId || key.id} - ${key.keyFunction || ''}`,
    }));

    const cylinderOptions = _.map(cylindersContent, cylinder => ({
      value: {...cylinder },
      label: `${cylinder.doorName || cylinder.marking || cylinder.externalId || cylinder.id} - ${cylinder.type || ''}`,
    }));

    console.log(formValues);
    
    return (
      <div>
        <FormFlatContainer
          title="requestType"
          subtitle="requestTypeSubtitle"
          containerStyle={{ marginRight: 15, marginTop: 0 }}
        >
          <Field
            id="selectRequestType"
            name="requestType"
            title={<Entity entity="selectRequestType" />}
            component={CustomField}
            mandatory
            className="form-control-select"
            componentClass="select"
            onHandleChange={requestType => this.onRequestTypeSelected(requestType)}
          >
            {_.map(requestTypeOptions, option => (
              <Entity
                key={option.value}
                componentClass={TranslatableOption}
                value={option.value}
                componentAttribute="text"
                entity={option.label}
              />
            ))}
          </Field>
        </FormFlatContainer>

        {requestType === MKS_REQUEST_TYPES.KEY_DUPLICATION && (
          <FormFlatContainer
            title="keyDuplicationItems"
            subtitle="keyDuplicationItemsSubtitle"
            icon={<KeyOutlinedIconCustom style={{ width: 22, color: '#3f3f3f' }} />}
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <FieldArray
              name="keysDuplicates"
              component={props => this.renderKeyDuplicationItem(props)}
            />
          </FormFlatContainer>
        )}

        {requestType === MKS_REQUEST_TYPES.CYLINDER_DUPLICATION && (
          <FormFlatContainer
            title="cylinderDuplicationItems"
            subtitle="cylinderDuplicationItemsSubtitle"
            icon={<LockOpenOutlined style={{ fontSize: 22, color: '#3f3f3f' }} />}
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <FieldArray
              name="cylindersDuplicates"
              component={props => this.renderCylinderDuplicationItem(props)}
            />
          </FormFlatContainer>
        )}

        {requestType === MKS_REQUEST_TYPES.KEY_EXTENSION && (
          <FormFlatContainer
            title="keyExtensionItems"
            subtitle="keyExtensionItemsSubtitle"
            icon={<LockOpenOutlined style={{ fontSize: 22, color: '#3f3f3f' }} />}
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <Field
              name="cylinders"
              component={SelectableField}
              title={<Entity entity="selectCylinders" />}
              placeholder={<Entity entity="selectCylindersPlaceholder" />}
              options={cylinderOptions}
              multi
              mandatory
            />
          </FormFlatContainer>
        )}

        {requestType === MKS_REQUEST_TYPES.CYLINDER_EXTENSION && (
          <FormFlatContainer
            title="cylinderExtensionItems"
            subtitle="cylinderExtensionItemsSubtitle"
            icon={<KeyOutlinedIconCustom style={{ width: 22, color: '#3f3f3f' }} />}
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <Field
              name="keys"
              component={SelectableField}
              title={<Entity entity="selectKeys" />}
              placeholder={<Entity entity="selectKeysPlaceholder" />}
              options={keyOptions}
              multi
              mandatory
              //onSelect={keys => dispatch(change('MksRequestForm', 'selectedKeys', keys))}
            />
          </FormFlatContainer>
        )}

        {requestType && (
          <FormFlatContainer
            title="additionalInformation"
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <Entity
              componentClass={Field}
              name="notes"
              componentAttribute="placeholder"
              entity="insertNotesMksRequest"
              containerStyle={{ marginTop: 10 }}
              title={<Entity entity="notes" />}
              type="textarea"
              component={CustomField}
              mandatory
            />
          </FormFlatContainer>
        )}
        {requestType && (
          <FormFlatContainer
            title="attachments"
            subtitle="attachmentsSubtitle"
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            {filePreviews && _.isArray(filePreviews) && filePreviews.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 15 }}>
                {_.map(filePreviews, (filePreview, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      position: 'relative',
                      margin: 10,
                      padding: 10,
                      backgroundColor: '#f5f5f5',
                      borderRadius: 8,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <FileCheckIconCustom
                      style={{ width: 20, marginRight: 10, color: BLUE }}
                    />
                    <h5 style={{ margin: 0, maxWidth: 200, wordBreak: 'break-all' }}>{filePreview.name}</h5>
                    <IconButton
                      onClick={() => this.onDeleteFile(index)}
                      style={{ fontSize: 20, cursor: 'pointer', color: RED, marginLeft: 10 }}
                    >
                      <RemoveCircleOutlineIcon style={{ fontSize: 20, color: RED }} />
                    </IconButton>
                  </div>
                ))}
              </div>
            ) : null}
            <Field
              name="documents"
              className="drop-file-container"
              activeClassName="drop-file-container-active"
              multiple
              maxSize={10 * 1048576}
              component={DropFileMultiField}
              onFileRejected={() => onFileRejected && onFileRejected()}
            >
              <h5 style={{ marginBottom: 5 }}>{<Entity entity="dropFile" />}</h5>
              <h5 style={{ marginTop: 0, marginBottom: 5 }}>{<Entity entity="orSelect" />}</h5>
              <h5 style={{ marginTop: 0 }}>({<Entity entity="maxUploadSizeDynamic" data={{ megabytes: 10 }} />})</h5>
            </Field>
          </FormFlatContainer>
        )}
      </div>
    );
  }
}

export default reduxForm({
  form: 'MksRequestForm',
})(MksRequestForm);

